import { ListItemCard } from '@monorepo/shared/componentsV2/ListItemCard';
import React from 'react';
import { ActionMenu } from '../../menus/ActionMenu';

type FieldTypePreviewProps = {
  actionMenuOptions?: React.ComponentProps<typeof ActionMenu>['options'];
  additionalInfo?: React.ReactElement | string;
  className?: string;
  fieldName: string | React.ReactNode;
  fieldTypeName?: string;
  icon?: React.ReactElement;
  iconTooltip?: string;
  isLocked?: boolean;
  isRequired?: boolean;
  link?: {
    to: string;
    title: string;
  };
  lockedIconTooltip?: string;
  outerElement?: React.ElementType | keyof JSX.IntrinsicElements;
};

export function FieldTypePreview({
  actionMenuOptions,
  additionalInfo,
  className,
  fieldName,
  fieldTypeName = 'field',
  icon,
  iconTooltip,
  isLocked = false,
  isRequired = false,
  link,
  lockedIconTooltip,
  outerElement = 'li',
}: FieldTypePreviewProps) {
  return (
    <ListItemCard
      actionMenuAltText={`Action menu for ${fieldName} ${fieldTypeName}`}
      actionMenuOptions={actionMenuOptions}
      additionalInfo={additionalInfo}
      className={className}
      content={fieldName}
      icon={icon}
      iconTooltip={iconTooltip}
      isLocked={isLocked}
      link={link}
      lockedIconTooltip={
        lockedIconTooltip ||
        `The ${fieldName} ${fieldTypeName} cannot be edited.`
      }
      outerElement={outerElement}
      qualifier={isRequired ? 'Required' : undefined}
    />
  );
}
